import React, { useContext } from 'react';

import { Icon } from 'components';
import {
  ContactDrawerContext,
  ContactDrawerMode,
  ContactDrawerType,
} from 'contexts';
import { featureEnabled } from 'utils';
import { NoContactsSVG } from '@brokerbay/elements-web';
import { EmptyContainer, EmptySection } from '../components';
import { BrokerageUser } from './types';
import { StyledContactItemContainer } from './styled';
import BrokerageUserItem from './BrokerageUserItem';

type BrokerageCardContentProps = {
  users: BrokerageUser[];
};

const ContactCardContent: React.FC<BrokerageCardContentProps> = ({ users }) => {
  const { openContactDrawer } = useContext(ContactDrawerContext);

  if (!users.length) {
    if (featureEnabled('showingsMadeEasyFeature')) {
      return (
        <EmptySection
          dataCy="no-contacts"
          Image={<NoContactsSVG width={200} height={120} />}
          mainText="No contacts yet"
          secondaryText="Add contacts to view them here."
        />
      );
    }
    return (
      <EmptyContainer data-cy="no-brokerage-users">
        <Icon type="antdHomeFilled" width={34} color="gray6" offset={[0, 2]} />
        <span>No brokerage users yet</span>
      </EmptyContainer>
    );
  }

  return (
    <>
      {users.map((user, index) => (
        <StyledContactItemContainer
          key={index}
          onClick={() => {
            openContactDrawer(
              ContactDrawerMode.Profile,
              ContactDrawerType.User,
              user.id,
            );
          }}
        >
          <BrokerageUserItem user={user} />
        </StyledContactItemContainer>
      ))}
    </>
  );
};

export default ContactCardContent;
